import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { portValidator } from 'src/app/shared/validators/port-validator';
import { urlValidator } from 'src/app/shared/validators/url-validator';
import {
    isFiveTranConnectionType,
    isLegacyConnectionType,
    isSqlConnectionType
} from 'src/app/shared/utils/connection-type.util';

export function legacyConnectionDetailsValidator(control: AbstractControl): ValidationErrors | null {
    const form: FormGroup = <FormGroup>control;

    const connectionString = form.controls['connectionString'];
    const host = form.controls['host'];
    const port = form.controls['port'];
    const user = form.controls['user'];
    const password = form.controls['password'];
    const database = form.controls['database'];
    const isNonLegacyConnectionType = form.controls['usingDynamicConnectionType'];

    // Reset error states
    connectionString.setErrors(null);
    host.setErrors(null);
    port.setErrors(null);
    user.setErrors(null);
    password.setErrors(null);
    database.setErrors(null);

    if (isNonLegacyConnectionType.value) {
        return null;
    }

    if (isUsingConnectionString(form)) {
        if (
            !connectionString.value &&
            (isConnectionDetailsUpdate(form) || hasConnectionStringError(form) || !isEdit(form))
        ) {
            connectionString.setErrors({ required: true });
        }

        return null;
    } else {
        if (!host.value) {
            host.setErrors({ required: true });
        } else {
            host.setErrors(urlValidator(host));
        }

        if (
            form.controls['connectionType'].value &&
            form.controls['connectionType'].value.toLowerCase() == 'sftp' &&
            !port.value
        ) {
            port.setErrors({ required: true });
        }

        if (port.value) {
            port.setErrors(portValidator(port));
        }

        if (!user.value) {
            user.setErrors({ required: true });
        }

        if (!password.value && (isConnectionDetailsUpdate(form) || hasConnectionStringError(form) || !isEdit(form))) {
            password.setErrors({ required: true });
            password.markAsTouched();
        }

        const connectionType = form.controls['connectionType'].value;
        if (isSqlConnectionType(connectionType) && !database.value) {
            database.setErrors({ required: true });
        }

        return null;
    }
}

function isUsingConnectionString(form: FormGroup): boolean {
    const usingConnectionString = form.controls['usingConnectionString'].value;
    const connectionType = form.controls['connectionType'].value;

    return (
        usingConnectionString || (!isLegacyConnectionType(connectionType) && !isFiveTranConnectionType(connectionType))
    );
}

function isConnectionDetailsUpdate(form: FormGroup): boolean {
    return (
        (isEdit(form) &&
            (form.controls['host'].dirty ||
                form.controls['database'].dirty ||
                form.controls['port'].dirty ||
                form.controls['user'].dirty ||
                form.controls['password'].dirty ||
                form.controls['connectionString'].dirty)) ||
        form.controls['usingConnectionString'].dirty
    );
}

function isEdit(form: FormGroup): boolean {
    return form.controls['tenantSourceId'].value;
}

function hasConnectionStringError(form: FormGroup): boolean {
    return form.controls['error'].value;
}
